"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dumpVideoElement = dumpVideoElement;
const video_element_1 = require("../../../api/typings/video-element");
function dumpVideoElement(videoEl) {
    var _a, _b, _c, _d;
    if (videoEl == null) {
        return {};
    }
    const videoLogs = {
        playDebugHasSrcObject: videoEl.srcObject != null,
        playDebugMuted: videoEl.muted,
        playDebugPaused: videoEl.paused,
        playDebugHeight: videoEl.videoHeight,
        playDebugWidth: videoEl.videoWidth,
        playDebugAutoplay: videoEl.autoplay,
        playDebugReadyState: videoEl.readyState,
        playDebugPlaysInLineAttr: (_a = videoEl.getAttribute("playsinline")) !== null && _a !== void 0 ? _a : "undefined",
        playDebugWebkitPlaysInLineAttr: (_b = videoEl.getAttribute("webkit-playsinline")) !== null && _b !== void 0 ? _b : "undefined",
    };
    if ((0, video_element_1.isMediaStream)(videoEl.srcObject)) {
        videoLogs.playDebugHasAudioTrack = ((_c = videoEl.srcObject) === null || _c === void 0 ? void 0 : _c.getAudioTracks().length) > 0;
        videoLogs.playDebugHasVideoTrack = ((_d = videoEl.srcObject) === null || _d === void 0 ? void 0 : _d.getVideoTracks().length) > 0;
    }
    return videoLogs;
}
//# sourceMappingURL=play-logs.js.map